import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import QRCode from 'qrcode.react'

const EventQrCode = ({ eventUrl, classes }) => (
  <Box className={classes.qrCodeBlock}>
    <Typography className={classes.sectionLabel}>Event QR code</Typography>
    <Box className={classes.qrCodeSection}>
      <QRCode
        value={eventUrl}
        id="event-details-qr-code"
        size={120}
        level="H"
        className={classes.qrCode}
      />
    </Box>
    <Typography className={classes.qrCodeCaption}>
      Download and share this code to help students register quickly.
    </Typography>
  </Box>
)

export default EventQrCode
